import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import type { BreadcrumbData } from '../../../contracts';
import { sharedSelectors } from '../../ducks';
import type { RootState } from '../../../store/types';
import { LeftArrowIcon, BreadcrumbContainer, NavigationLabel } from './Breadcrumb.styles';

type StateProps = {
  breadcrumbData: BreadcrumbData;
};

const Breadcrumb = ({ breadcrumbData }: StateProps) => {
  const { displayName, backUrl } = breadcrumbData;
  return (
    <NavLink to={backUrl}>
      <BreadcrumbContainer>
        <LeftArrowIcon />
        <NavigationLabel>{displayName}</NavigationLabel>
      </BreadcrumbContainer>
    </NavLink>
  );
};

const mapStateToProps = (state: RootState) => ({
  breadcrumbData: sharedSelectors.getBreadcrumbData(state)
});

export default connect(mapStateToProps)(Breadcrumb);
